import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const EnrollNowSlide = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if (!open) return;
      const panel = document.getElementById('enroll-now-panel');
      const toggleButton = document.getElementById('enroll-toggle-button');
      if (panel && !panel.contains(e.target) && !toggleButton?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <>
      {/* Floating toggle that stays at screen edge */}
      <button
        id="enroll-toggle-button"
        aria-label={open ? 'Close enroll panel' : 'Open enroll panel'}
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
        className={`fixed right-0 top-1/3 z-[70] flex items-center justify-center w-8 h-10 rounded-l-lg bg-[var(--color-primary)] text-[var(--color-text-inverse)] shadow-md hover:bg-[var(--color-primary-hover)] transition-colors`}
      >
        <svg className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      {/* Panel */}
      <div
        id="enroll-now-panel"
        className={`fixed right-0 top-1/4 z-[60] w-[260px] max-w-[85vw] bg-[var(--color-surface)] border border-[var(--color-border)] rounded-l-xl shadow-xl overflow-hidden transition-transform duration-300 ${open ? 'translate-x-0' : 'translate-x-full'}`}
      >
        {/* Fixed Header */}
        <div className="p-4 bg-gradient-to-r from-[var(--color-primary)]/10 to-[var(--color-secondary)]/10">
          <h3 className="text-lg font-bold text-[var(--color-text-primary)]">Pre Registration</h3>
          <p className="text-xs text-[var(--color-text-secondary)]">Pre Registration for Batch 2</p>
        </div>
        
        {/* Single Homeschooling Button */}
        <div className="p-4">
          <Link to="/homeschooling#homeschooling-registration" className="block">
            <button className="w-full py-2.5 px-4 rounded-lg bg-gradient-to-r from-[var(--color-secondary)] to-[var(--color-secondary-hover)] text-[var(--color-text-inverse)] font-semibold hover:opacity-95 transition-all duration-150 shadow-md hover:shadow-lg">
              <div className="flex items-center justify-center gap-2">
                <span className="text-xl">🏠</span>
                <span className="text-sm">Homeschooling Batch 2</span>
              </div>
            </button>
          </Link>

          <div className="mt-3 p-2.5 bg-gray-50 rounded-md">
            <p className="text-[11px] text-[var(--color-text-muted)] text-center">
              By proceeding, you agree to our terms and policies.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnrollNowSlide;


